/* Feature + Category Grid — carousel, countdown, entrance reveal, analytics */
(function () {
  'use strict';

  /* ---- Shared countdown ticker (one interval for the whole page) ---- */
  var countdowns = [];
  var cdTimer = null;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickAll() {
    var now = Date.now();
    for (var i = countdowns.length - 1; i >= 0; i--) {
      var cd = countdowns[i];
      var diff = cd.end - now;
      if (diff <= 0) {
        handleExpire(cd);
        countdowns.splice(i, 1);
        continue;
      }
      var s = Math.floor(diff / 1000);
      if (cd.d) cd.d.textContent = pad(Math.floor(s / 86400));
      if (cd.h) cd.h.textContent = pad(Math.floor((s % 86400) / 3600));
      if (cd.m) cd.m.textContent = pad(Math.floor((s % 3600) / 60));
      if (cd.s) cd.s.textContent = pad(s % 60);
    }
    if (!countdowns.length && cdTimer) { clearInterval(cdTimer); cdTimer = null; }
  }
  function handleExpire(cd) {
    var mode = cd.el.getAttribute('data-expire') || 'hide_countdown';
    var section = cd.el.closest('[data-fcg]');
    emit(section, 'fcg_countdown_expired', { end_date: cd.end });
    if (mode === 'hide_section' && section) { section.style.display = 'none'; }
    else if (mode === 'show_message') { cd.el.innerHTML = '<span class="fcg-cd__expired">' + (cd.el.getAttribute('data-expired-message') || '') + '</span>'; }
    else if (mode === 'hide_countdown') { cd.el.style.display = 'none'; }
  }
  function initCountdown(el) {
    var end = parseInt(el.getAttribute('data-end'), 10);
    if (!end) return;
    countdowns.push({
      el: el, end: end * 1000,
      d: el.querySelector('[data-days]'),
      h: el.querySelector('[data-hours]'),
      m: el.querySelector('[data-minutes]'),
      s: el.querySelector('[data-seconds]')
    });
    if (!cdTimer) { tickAll(); cdTimer = setInterval(tickAll, 1000); }
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { if (cdTimer) { clearInterval(cdTimer); cdTimer = null; } }
    else if (countdowns.length && !cdTimer) { tickAll(); cdTimer = setInterval(tickAll, 1000); }
  });

  /* ---- Analytics ---- */
  function emit(section, name, extra) {
    if (!section || section.getAttribute('data-analytics') !== 'true') return;
    var payload = Object.assign({ section_id: section.id || null }, extra || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    window.dispatchEvent(new CustomEvent(name, { detail: payload }));
  }

  /* ---- Feature carousel ---- */
  function initCarousel(feature) {
    var slides = Array.prototype.slice.call(feature.querySelectorAll('[data-fcg-slide]'));
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(feature.querySelectorAll('[data-fcg-dot]'));
    var prev = feature.querySelector('[data-fcg-prev]');
    var next = feature.querySelector('[data-fcg-next]');
    var current = 0;
    var autoplay = parseInt(feature.getAttribute('data-autoplay'), 10) || 0;
    var pauseHover = feature.hasAttribute('data-pause-hover');
    var section = feature.closest('[data-fcg]');
    var timer = null;

    function show(idx, method) {
      idx = (idx + slides.length) % slides.length;
      if (idx === current) return;
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      var from = current;
      current = idx;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
      emit(section, 'fcg_carousel_change', { from_index: from, to_index: current, method: method || 'auto' });
    }
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === 0); });

    if (prev) prev.addEventListener('click', function () { show(current - 1, 'arrow'); });
    if (next) next.addEventListener('click', function () { show(current + 1, 'arrow'); });
    dots.forEach(function (d) { d.addEventListener('click', function () { show(parseInt(d.getAttribute('data-fcg-dot'), 10), 'dot'); }); });

    /* swipe */
    var sx = 0;
    feature.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    feature.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) show(current + (dx < 0 ? 1 : -1), 'swipe');
    }, { passive: true });

    function start() { if (autoplay) { stop(); timer = setInterval(function () { show(current + 1, 'auto'); }, autoplay); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (autoplay) {
      start();
      if (pauseHover) {
        feature.addEventListener('mouseenter', stop);
        feature.addEventListener('mouseleave', start);
      }
    }
    feature.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(current - 1, 'arrow');
      else if (e.key === 'ArrowRight') show(current + 1, 'arrow');
    });
  }

  /* ---- Entrance reveal ---- */
  function initReveal(section) {
    // No animation requested → content is visible by default (no .fcg--anim).
    if (!section.hasAttribute('data-fcg-anim')) { emit(section, 'fcg_section_view', {}); return; }
    var reduce = section.getAttribute('data-reduced-motion') !== 'false' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { emit(section, 'fcg_section_view', {}); return; }

    // Engage the animation (hides items) then reveal when in view.
    section.classList.add('fcg--anim');
    var revealed = false;
    function reveal() { if (revealed) return; revealed = true; section.classList.add('is-in'); emit(section, 'fcg_section_view', {}); }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { reveal(); obs.disconnect(); } });
    }, { threshold: 0.12 });
    obs.observe(section);
    // Safety net: if already in view on load (or observer is slow), reveal shortly after.
    requestAnimationFrame(function () {
      var r = section.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) reveal();
    });
    setTimeout(reveal, 1200);
  }

  /* ---- Card + CTA click analytics ---- */
  function initAnalytics(section) {
    section.addEventListener('click', function (e) {
      var card = e.target.closest('.fcg-cat');
      if (card) {
        var slot = card.closest('.fcg-cat-slot');
        var idx = slot ? Array.prototype.indexOf.call(section.querySelectorAll('.fcg-cat-slot'), slot) : -1;
        emit(section, 'fcg_card_click', { card_index: idx, title: (card.querySelector('.fcg-cat__title') || {}).textContent, url: card.getAttribute('href') });
        return;
      }
      var cta = e.target.closest('.fcg-feature__cta, .fcg-feature__cta-text');
      if (cta) emit(section, 'fcg_feature_click', { cta_label: cta.textContent.trim(), url: cta.getAttribute('href') });
    });

    /* whole-slide clickable */
    section.querySelectorAll('[data-slide-link]').forEach(function (slide) {
      slide.style.cursor = 'pointer';
      slide.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        window.location.href = slide.getAttribute('data-slide-link');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-fcg]').forEach(function (section) {
      if (section.__fcgInit) return;
      section.__fcgInit = true;
      section.querySelectorAll('[data-fcg-countdown]').forEach(initCountdown);
      var feature = section.querySelector('[data-fcg-feature][data-carousel]');
      if (feature) initCarousel(feature);
      initReveal(section);
      initAnalytics(section);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
